import { Component, OnInit, Inject, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CompareFields } from 'src/app/utils/form-validation/compare-fields.validation';
import { RecuperarSenhaService } from 'src/app/services/recuperar-senha/recuperar-senha.service';

@Component({
  selector: 'app-modal-recuperar',
  templateUrl: './modal-recuperar.component.html',
  styleUrls: ['./modal-recuperar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,

})
export class ModalRecuperarComponent implements OnInit {
    formUserName: FormGroup = new FormGroup({
        userName: new FormControl(null, [Validators.required])
    },);

    formCheck: FormGroup = new FormGroup({
        checkEmail: new FormControl(null, [Validators.required])
    },);

    formNovaSenha: FormGroup = new FormGroup({
        codSegurança: new FormControl(null, [Validators.required]),
        novaSenha: new FormControl(null, [Validators.required]),
        confirmarSenha: new FormControl(null, [Validators.required])
    },
        CompareFields('novaSenha', 'confirmarSenha')
    );

    telaModalR = 0;
    error: boolean = false;
    usuario = null;

    constructor(
        private recuperarsenha: RecuperarSenhaService,
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<ModalRecuperarComponent>,
    ) {

    }
    ngOnInit(): void {
    }

    mudarPainelModal(tela: number): void {
        this.telaModalR = tela;
    }
    
    close(): void {
        this.dialogRef.close();
    }

    getUsuario(): void {
        this.recuperarsenha.getUsuario(this.formUserName.get('userName').value)
            .subscribe(val => {
                if (val['status'] === 'error') return this.error = true;
                else this.usuario = val;
                this.telaModalR = 1;
            })
    }

    compararEmails(): void {
        const usuarioemail = this.formCheck.get('checkEmail').value
        if (usuarioemail === this.usuario.email)
            this.enviarEmail(),
            this.telaModalR = 2;
        else (<HTMLInputElement>document.getElementById('iderroemail')).style['content-visibility'] = 'visible';
    }

    enviarEmail(): void {
        const usuarioId = this.usuario.usuarioId
        const nome = this.usuario.nome
        const email = this.usuario.email
        const oid = this.usuario.oid
        const contraSenha = ""
        const senha = ""
        const confirmaSenha = ""

        this.recuperarsenha.enviarEmail(
            {usuarioId, nome, email, oid, contraSenha, senha, confirmaSenha}
        )
            .subscribe(val => {
                if (val['status'] === 'error') return this.error = true;
                else this.usuario = val;
            })
    }

    redefinirSenha(): void {
        this.usuario
        const usuarioId = this.usuario.usuarioId
        const nome = this.usuario.nome
        const email = this.usuario.email
        const oid = this.usuario.oid
        const contraSenha = this.formNovaSenha.get('codSegurança').value
        const senha = this.formNovaSenha.get('novaSenha').value
        const confirmaSenha = this.formNovaSenha.get('confirmarSenha').value

        if (senha !== confirmaSenha) {
            (<HTMLInputElement>document.getElementById('iderrosenhadiferente')).style['content-visibility'] = 'visible';
            return;
        }

        this.recuperarsenha.redefinirSenha(
            {usuarioId, nome, email, oid, contraSenha, senha, confirmaSenha}
        )
            .subscribe(val => {
                if (val['status'] === 'error') return this.error = true;
                else this.usuario = val;
                this.telaModalR = 4;
            })
    }

}